const React = require('react');
const withState = require("../../../../../../../../utils/withState");
const isEmail = require("mn-utils/isEmail");
const TextField = require("../../../../../../../dumb/TextField/H");
const WrapperWithLoading = require("../../../../../../../dumb/WrapperWithLoading");
const SelectCC = require("../../../../../../../dumb/SelectCC");
const Popup = require("../../../../../../../dumb/Popup/C");
const changeProviderProvider = require("mn-utils/changeProviderProvider");
const handleProviderProvider = require("mn-utils/changeProviderProviderSimple");
const {FIAT_CODES, CC_CODES_UNREFUNDABLE} = require("../../../../../../../../constants/codes");
const Select = require('../../../../../../../dumb/Select/B');
const {handleFiatFieldResult, handleCoinField} = require('../../../../../../../../utils/formatFieldNumResult');

const hashCheck = (hash, data = {}) => {
  const code = data['cc_code'];

  if (!code) return true;

  const regexBPAY = /^([0-9]{18})$/;

  if (regexBPAY.test(hash)) return true;

  const regexETH = /^0x([A-Fa-f0-9]{64})$/;
  const regexDefault = /^[a-fA-F0-9]{64}$/;

  const checks = {
    BNB: regexETH,
    ETH: regexETH,
    ETH_USDT: regexETH
  };

  const check = checks[code] || regexDefault;

  return check.test(hash);
}

module.exports = ({caption, state, setState, update, close, onSave}) => {
  const {
    crypto_code: cryptoCode,
    crypto_network: cryptoNetwork,
    refund_crypto_code: refundCryptoCode,
    refund_crypto_network: refundCryptoNetwork,
    clicked
  } = state;

  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);

  const isNaNError = {
    check: (val) => !isNaN(val),
    helperText: 'Must be a number'
  };

  const invalidCryptoCode = !cryptoCode;
  const invalidCryptoNetwork = !cryptoNetwork;

  const required = true;

  const fields = [
    {
      id: 'buyer_email',
      label: 'Email',
      checks: [{
        check: isEmail,
        helperText: 'Invalid email format'
      }],
      required
    },
    {
      id: 'tx_hash',
      label: 'Hash',
      checks: [{
        check: hashCheck,
        helperText: 'Invalid hash format'
      }],
      required
    },
    // {
    //   id: 'fiat_amount',
    //   label: 'Fiat Amount',
    //   checks: [isNaNError],
    //   onChange: handleFiatFieldResult,
    //   required
    // },
    // {
    //   id: 'fiat_code',
    //   component: Select,
    //   label: 'Fiat Code',
    //   items: FIAT_CODES,
    //   value: state['fiat_code'],
    //   onChange: handleProvider('fiat_code'),
    //   required
    // },
    {
      id: 'cc_amount',
      label: 'Crypto Amount',
      checks: [isNaNError],
      onChange: handleCoinField,
      required
    },
    {
      id: 'cc_code',
      component: SelectCC,
      filterFn: (code) => !CC_CODES_UNREFUNDABLE.includes(code),
      codeProps: {
        id: 'crypto_code',
        label: 'Crypto Code *',
        value: cryptoCode,
        error: clicked && invalidCryptoCode
      },
      networkProps: {
        id: 'crypto_network',
        label: 'Crypto Network *',
        value: cryptoNetwork,
        error: clicked && invalidCryptoNetwork
      },
      onChange: (data) => {
        data['refund_cc_code'] = data['cc_code'];
        data['refund_crypto_code'] = data['crypto_code'];
        data['refund_crypto_network'] = data['crypto_network'];
        setState(data);
      }
    },
    {
      id: 'refund_cc_code',
      component: SelectCC,
      filterFn: (code) => !CC_CODES_UNREFUNDABLE.includes(code),
      codeProps: {
        id: 'refund_crypto_code',
        label: 'Refund Code *',
        value: refundCryptoCode || cryptoCode,
        disabled: true
      },
      networkProps: {
        id: 'refund_crypto_network',
        label: 'Refund Network *',
        value: refundCryptoNetwork || cryptoNetwork
      },
      onChange: setState
    },
    {
      id: 'refund_address',
      label: 'Refund Address',
      required
    },
    {
      id: 'refund_address_tag',
      label: 'Refund Address Tag'
    },
    {
      id: 'auction_id',
      label: 'Auction ID',
      checks: [{
        check: (val) => /^\{?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\}?$/.test(val),
        helperText: 'Invalid UUID format'
      }],
      required
    },
    {
      id: 'reason',
      label: 'Refund reason',
      maxLength: 150,
      required
    },
    {
      id: 'description',
      label: 'Description'
    }
  ];

  const disabled = fields.some(({id, required, checks}) => {
    const value = state[id];

    if (required && !value) return true;

    return !!checks && value
      ? checks.some(({check}) => !check(value))
      : false;
  }) || invalidCryptoCode || invalidCryptoNetwork;

  return (
    <Popup
      caption={caption}
      onCancel={close}
      disabled={state.loading || (clicked && disabled)}
      onSave={() => {
        if (disabled) {
          setState({clicked: true});
          return;
        }

        if (!onSave) return;

        const data = {};

        fields.forEach(({id}) => {
          if (state[id]) data[id] = state[id];
        });

        setState({loading: true});

        onSave(data).then(() => {
          update();
          close();
        }).catch((err) => {
          console.error(err);
        }).finally(() => {
          setState({loading: false})
        });
      }}
    >
      <WrapperWithLoading
        loading={state.loading}
      >
        {fields.map(({id, component: C, label, checks, required, onChange, ...rest}) => {

          const className = 'mt20 wmax472';
          const value = state[id];

          let helperText;

          if (clicked) {
            if (required && !value) {
              helperText = 'Obligatory field';
            } else {
              if (!!checks && checks.length && value) {
                const failedCheck = checks.find(({check}) => check && !check(value, state)) || {};
                helperText = failedCheck.helperText
              }
            }
          }

          if (label && required) label = [label, '*'].join(' ');

          return C
            ? (
              <C
                key={id}
                id={id}
                className={className}
                label={label}
                value={state[id]}
                error={!!helperText}
                helperText={helperText}
                clicked={clicked}
                onChange={onChange}
                {...rest}
              />
            ) : (
              <TextField
                key={id}
                id={id}
                className={className}
                label={label}
                value={state[id] || ""}
                onChange={onChange
                  ? (e) => {
                    changeProvider(id)({target: {value: onChange(e.target.value)}});
                  }
                  : changeProvider(id)
                }
                error={!!helperText}
                helperText={helperText}
                clicked={clicked}
                {...rest}
              />
            )
        })}
      </WrapperWithLoading>
    </Popup>
  );
}
